import React, { useEffect, useMemo, useRef, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import Api from "services/api";
import toast from "react-hot-toast";
import { ListLayout } from "components/common/ListLayout";
import TableHeaderItem from "components/common/ListLayout/TableHeaderItem";
import { userSelector } from "slices/userSlice";
import { usePermissions } from "layouts/Admin";
import { Controller, useForm } from "react-hook-form";
import moment from "moment";
import { SubmitButton } from "components/common/buttons/SubmitButton";
import { AsyncPaginate } from "react-select-async-paginate";
import { selectCustomStyles } from "components/common/Select";
import ErrorMessage from "components/common/ErrorMessage";
// import { fetchInterpreters } from "slices/interpreterSlice";
import { fetchAdminInterpreterTimesheets, fetchInterpreters, fetchSingleAdminInterpreterTimesheets } from "slices/timesheetSlice"; // ✅ create this slice
import ExcelJS from "exceljs";
import { saveAs } from 'file-saver';
import { Button, Modal, ModalHeader, ModalBody, Table } from "reactstrap";

const apiService = new Api();

function InterpreterTimesheets() {
  const dispatch = useDispatch();
  const { checkPermission } = usePermissions();
  const { user } = useSelector(userSelector);
  const userToken = user.token;
  const [hasFiltered, setHasFiltered] = useState(false);
  const [paginationParams, setPaginationParams] = useState({});
  const [paginationParamsInterpreter, setPaginationParamsInterpreter] = useState({});
  const filtersRef = useRef({});
  const {
    timesheets,
    interpreterTimesheets,
    loader,
    total,
    last_page: totalPages,
    current_page,
    per_page: pageLength,
  } = useSelector((state) => state.timesheet || {});

  console.log(interpreterTimesheets, '111111111')

  const [currentPage, setCurrentPage] = useState(1);
  const [searchTerm, setSearchTerm] = useState("");
  const [sortConfig, setSortConfig] = useState({
    sortBy: "date",
    sortDirection: "desc",
  });

  // Modal State
  const [viewModal, setViewModal] = useState(false);
  const [selectedRow, setSelectedRow] = useState(null);
  const [modalLogs, setModalLogs] = useState([]);
  const [modalTotal, setModalTotal] = useState(0);
  const [modalTotalPages, setModalTotalPages] = useState(1);
  const [modalCurrentPage, setModalCurrentPage] = useState(1);
  const [modalLoader, setModalLoader] = useState(false);

  const toggleViewModal = () => {
    setViewModal(!viewModal);
    if (viewModal) {
      setSelectedRow(null);
      setModalLogs([]);
    }
  };

  const handleView = (row) => {
    setSelectedRow(row);
    setPaginationParamsInterpreter({ interpreter_id: row.interpreter_id, start_date: row.start_date, end_date: row.end_date });
    setModalCurrentPage(1);
    setViewModal(true);
    dispatch(fetchSingleAdminInterpreterTimesheets({ interpreter_id: row.interpreter_id, start_date: row.start_date, end_date: row.end_date }));
  };

  // Filters state
  const [interpreterState, setInterpreterState] = useState([]);
  const defaultValues = {
    start_date: "",
    end_date: "",
    interpreter_ids: [],
  };

  const {
    handleSubmit,
    control,
    reset,
    formState: { errors },
  } = useForm({ defaultValues });

  console.log('>>> Redux timesheet state:', useSelector((state) => state.timesheet));
  console.log('>>> timesheets (local variable):', timesheets);


  //#region FILTER HANDLERS

  const handleResetFields = () => {
    reset(defaultValues);
    setHasFiltered(false);
    setPaginationParams({});
    filtersRef.current = {};
    dispatch(fetchAdminInterpreterTimesheets(1, defaultValues));
  };

  const onSubmit = (data) => {
    setHasFiltered(true);
    setPaginationParams(data);
    filtersRef.current = data;
    dispatch(fetchAdminInterpreterTimesheets(1, data));
  };

  const filteredInterpreterLoadOptions = async (
    inputValue,
    loadedOptions,
    { page }
  ) => {
    const result = await dispatch(
      fetchInterpreters(
        page,
        {
          pageLength: 20,
          sortBy: "id",
          sortDirection: "asc",
          search: inputValue,
        },
        true,
        true
      )
    );

    return {
      options: result.data.map((item) => ({
        // prefer user_id, then user.id, then item.id
        value: item.user_id ?? item.user?.id ?? item.id,
        label: item.user?.name ?? item.name ?? `Interpreter ${item.id}`,
      })),
      hasMore: page !== result?.last_page,
      additional: { page: page + 1 },
    };
  };

  //#endregion

  //#region TABLE HEAD

  const renderTableHeader = React.useCallback(() => {
    const callBack = (dir, sortBy) => {
      setSortConfig({ sortBy, sortDirection: dir });
      dispatch(
        fetchAdminInterpreterTimesheets(currentPage, {
          sortBy,
          sortDirection: dir,
          search: searchTerm,
        })
      );
    };

    return (
      <tr>
        <th className="col-1">#</th>
        <th className="col-2">From Date</th>
        <th className="col-2">To Date</th>
        <th className="col-2">Interpreter Name</th>
        <th className="col-2">Action</th>
      </tr>
    );
  }, [sortConfig, currentPage, searchTerm]);


  const handleDownloadInterpreterTimesheet = async () => {
    try {
      // Step 1️⃣: Setup query params
      const params = {
        ...paginationParamsInterpreter, // includes start_date, end_date etc.
        sortBy: sortConfig?.sortBy,
        sortDirection: sortConfig?.sortDirection,
        search: searchTerm,
      };

      console.log("🚦 Export - fetching all pages with params:", params);

      let page = 1;
      let allData = [];
      let lastPage = 1;

      // Step 2️⃣: Fetch all pages (backend is paginated)
      do {
        const res = await Api.fetchSingleAdminInterpreterTimesheets(params);
        const response = res?.data;

        if (!response || !response.data) break;

        allData = [...allData, ...response.data];
        lastPage = response.pagination?.last_page || 1;

        console.log(`✅ Page ${page} fetched: ${response.data.length} items`);
        page++;
      } while (page <= lastPage);

      console.log("🚦 All pages combined:", allData.length);

      if (allData.length === 0) {
        toast.error("No data available to download.");
        return;
      }

      // ✅ Start Excel export logic
      const workbook = new ExcelJS.Workbook();
      const worksheet = workbook.addWorksheet("Timesheet");

      // ✅ Interpreter Name Row
      const interpreterName = allData[0]?.interpreter_name || "Interpreter";
      const title = `Timesheet for ${interpreterName}`;
      const titleRow = worksheet.addRow([title]);
      worksheet.mergeCells("A1:D1");
      titleRow.getCell(1).font = { name: "Calibri", size: 14, bold: true, color: { argb: "6C889C" } };
      titleRow.getCell(1).alignment = { horizontal: "center", vertical: "middle" };
      titleRow.height = 25;

      // ✅ Header Row
      const headers = ["#", "Date", "Check In/Out", "Daily Duration"];
      const headerRow = worksheet.addRow(headers);
      headerRow.eachCell((cell) => {
        cell.font = { name: "Calibri", size: 12, bold: true, color: { argb: "FFFFFFFF" } };
        cell.fill = { type: "pattern", pattern: "solid", fgColor: { argb: "6F8DFF" } };
        cell.alignment = { horizontal: "center", vertical: "middle" };
        cell.border = {
          top: { style: "thin" },
          left: { style: "thin" },
          bottom: { style: "thin" },
          right: { style: "thin" },
        };
      });
      worksheet.views = [{ state: "frozen", ySplit: 2 }];
      headerRow.height = 20;

      // ✅ Add Data Rows
      allData.forEach((item, index) => {
        worksheet.addRow([
          index + 1,
          moment(item.date).format("YYYY-MM-DD"),
          item.pairs || "N/A",
          item.daily_duration || "0h",
        ]);
      });

      // ✅ Auto Column Width
      worksheet.columns.forEach((col, index) => {
        if (index === 2) col.width = 100; // Check In/Out wide column
        else {
          let max = 0;
          col.eachCell({ includeEmpty: true }, (cell) => {
            const val = cell.value ? cell.value.toString() : "";
            max = Math.max(max, val.length);
          });
          col.width = max + 3;
        }
      });

      // ✅ Total Duration Calculation
      let totalMinutes = 0;
      allData.forEach((item) => {
        if (item.daily_duration) {
          const str = item.daily_duration.toString().trim().toLowerCase();
          let hours = 0, minutes = 0;
          if (str.includes("h")) {
            const hMatch = str.match(/(\d+)\s*h/);
            const mMatch = str.match(/(\d+)\s*m/);
            hours = hMatch ? parseInt(hMatch[1]) : 0;
            minutes = mMatch ? parseInt(mMatch[1]) : 0;
          } else if (str.includes(":")) {
            const [h, m] = str.split(":");
            hours = parseInt(h) || 0;
            minutes = parseInt(m) || 0;
          }
          totalMinutes += hours * 60 + minutes;
        }
      });

      const totalHours = Math.floor(totalMinutes / 60);
      const remainingMinutes = totalMinutes % 60;
      const totalFormatted = `${totalHours}h ${remainingMinutes}m`;
      const totalDays = allData.length;

      const daysRow = worksheet.addRow(["", "", "Total Days", totalDays]);
      const totalRow = worksheet.addRow(["", "", "Total Duration:", totalFormatted]);
      [daysRow, totalRow].forEach((row) => {
        row.eachCell((cell, colNumber) => {
          cell.font = { bold: true };
          cell.border = {
            top: { style: "thin" },
            left: { style: "thin" },
            bottom: { style: "thin" },
            right: { style: "thin" },
          };
          if (colNumber === 3) cell.alignment = { horizontal: "right" };
          if (colNumber === 4)
            cell.fill = { type: "pattern", pattern: "solid", fgColor: { argb: "D9E1F2" } };
        });
      });

      // ✅ Download Excel
      const buffer = await workbook.xlsx.writeBuffer();
      saveAs(
        new Blob([buffer], {
          type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
        }),
        `timesheet_${moment().format("YYYYMMDD_HHmmss")}.xlsx`
      );

      toast.success("Timesheet downloaded successfully!");
    } catch (err) {
      console.error("Export error:", err);
      toast.error("Failed to download timesheet. See console for details.");
    }
  };

  const [timesheetLoader, setTimesheetLoader] = useState(false);
  const handleDownloadTimesheet = async () => {
    if (!paginationParams?.start_date || !paginationParams?.end_date) {
        toast.error("From date and To date is required.");
        return;
    }
    setTimesheetLoader(true);
    try {
      // Step 1️⃣: Setup query params
      const params = {
        ...paginationParams, // includes start_date, end_date etc.
        sortBy: sortConfig?.sortBy,
        sortDirection: sortConfig?.sortDirection,
        search: searchTerm,
      };

      console.log("🚦 Export - fetching all pages with params:", params);

      let page = 1;
      let allData = [];
      let lastPage = 1;

      // Step 2️⃣: Fetch all pages (backend is paginated)
      do {
        const res = await Api.fetchAdminInterpreterTimesheets(page, params);
        const response = res?.data;

        if (!response || !response.data) break;

        allData = [...allData, ...response.data];
        lastPage = response.pagination?.last_page || 1;

        console.log(`✅ Page ${page} fetched: ${response.data.length} items`);
        page++;
      } while (page <= lastPage);

      console.log("🚦 All pages combined:", allData.length);

      if (allData.length === 0) {
        toast.error("No data available to download.");
        return;
      }

      // ✅ Start Excel export logic
      const workbook = new ExcelJS.Workbook();
      const worksheet = workbook.addWorksheet("Timesheet");

      // ✅ Interpreter Name Row
      const interpreterName = allData[0]?.interpreter_name || "Interpreter";
      const title = `Interpreter Timesheet`;
      const titleRow = worksheet.addRow([title]);
      worksheet.mergeCells("A1:F1");
      titleRow.getCell(1).font = { name: "Calibri", size: 14, bold: true, color: { argb: "6C889C" } };
      titleRow.getCell(1).alignment = { horizontal: "center", vertical: "middle" };
      titleRow.height = 25;

      // ✅ Header Row
      const headers = ["#", "From Date", "To Date", "Interpreter Name", "Total Duration" , "Total Amount"];
      const headerRow = worksheet.addRow(headers);
      headerRow.eachCell((cell) => {
        cell.font = { name: "Calibri", size: 12, bold: true, color: { argb: "FFFFFFFF" } };
        cell.fill = { type: "pattern", pattern: "solid", fgColor: { argb: "6F8DFF" } };
        cell.alignment = { horizontal: "center", vertical: "middle" };
        cell.border = {
          top: { style: "thin" },
          left: { style: "thin" },
          bottom: { style: "thin" },
          right: { style: "thin" },
        };
      });
      worksheet.views = [{ state: "frozen", ySplit: 2 }];
      headerRow.height = 20;

      // ✅ Add Data Rows
      allData.forEach((item, index) => {
        worksheet.addRow([
          index + 1,
          moment(item.start_date).format("YYYY-MM-DD"),
          moment(item.end_date).format("YYYY-MM-DD"),
          item.interpreter_name || "N/A",
          item.total_duration || "0h",
          // item.rate || "0.00",
          item.total_amount || "0.00"
        ]);
      });

      // ✅ Auto Column Width
      // worksheet.columns.forEach((col, index) => {
      //   if (index === 2) col.width = 100; // Check In/Out wide column
      //   else {
      //     let max = 0;
      //     col.eachCell({ includeEmpty: true }, (cell) => {
      //       const val = cell.value ? cell.value.toString() : "";
      //       max = Math.max(max, val.length);
      //     });
      //     col.width = max + 3;
      //   }
      // });

      // // ✅ Total Duration Calculation
      // let totalMinutes = 0;
      // allData.forEach((item) => {
      //   if (item.daily_duration) {
      //     const str = item.daily_duration.toString().trim().toLowerCase();
      //     let hours = 0, minutes = 0;
      //     if (str.includes("h")) {
      //       const hMatch = str.match(/(\d+)\s*h/);
      //       const mMatch = str.match(/(\d+)\s*m/);
      //       hours = hMatch ? parseInt(hMatch[1]) : 0;
      //       minutes = mMatch ? parseInt(mMatch[1]) : 0;
      //     } else if (str.includes(":")) {
      //       const [h, m] = str.split(":");
      //       hours = parseInt(h) || 0;
      //       minutes = parseInt(m) || 0;
      //     }
      //     totalMinutes += hours * 60 + minutes;
      //   }
      // });

      // const totalHours = Math.floor(totalMinutes / 60);
      // const remainingMinutes = totalMinutes % 60;
      // const totalFormatted = `${totalHours}h ${remainingMinutes}m`;
      // const totalDays = allData.length;

      // const daysRow = worksheet.addRow(["", "", "Total Days", totalDays]);
      // const totalRow = worksheet.addRow(["", "", "Total Duration:", totalFormatted]);
      // [daysRow, totalRow].forEach((row) => {
      //   row.eachCell((cell, colNumber) => {
      //     cell.font = { bold: true };
      //     cell.border = {
      //       top: { style: "thin" },
      //       left: { style: "thin" },
      //       bottom: { style: "thin" },
      //       right: { style: "thin" },
      //     };
      //     if (colNumber === 3) cell.alignment = { horizontal: "right" };
      //     if (colNumber === 4)
      //       cell.fill = { type: "pattern", pattern: "solid", fgColor: { argb: "D9E1F2" } };
      //   });
      // });

      // ✅ Download Excel
      const buffer = await workbook.xlsx.writeBuffer();
      saveAs(
        new Blob([buffer], {
          type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
        }),
        `timesheet_${moment().format("YYYYMMDD_HHmmss")}.xlsx`
      );

      toast.success("Timesheet downloaded successfully!");
    } catch (err) {
      console.error("Export error:", err);
      toast.error("Failed to download timesheet. See console for details.");
    } finally {
      setTimesheetLoader(false);
    }
  };


  //#endregion

  //#region TABLE BODY

  const renderTableContent = React.useCallback(() => {
    if (!hasFiltered || !timesheets?.length) {
      // ✅ Return empty fragment so table stays but shows no rows
      return <></>;
    }

    return timesheets.map((item, index) => (
      <TimesheetItems
        key={item.id}
        data={item}
        index={index}
        current_page={current_page}
        pageLength={pageLength}
        handleView={handleView}
      />
    ));
  }, [timesheets, hasFiltered]);

  // Modal Renderers
  const renderModalTableHeader = React.useCallback(() => {
    return (
      <tr>
        <th className="col-1">#</th>
        <th className="col-3">Date</th>
        <th className="col-4">Check In/Out</th>
        <th className="col-2">Daily Duration</th>
      </tr>
    );
  }, []);

  const renderModalTableContent = React.useCallback(() => {
    if (!interpreterTimesheets?.length) return <></>; // Or a no-data row inside ListLayout handling?

    return interpreterTimesheets.map((item, index) => (
      <tr key={index}>
        <td>{index + 1 + (modalCurrentPage - 1) * 10}</td>
        <td>{moment(item.date).format("YYYY-MM-DD")}</td>
        <td>{item.pairs || 'N/A'}</td>
        <td>{item.daily_duration}</td>
      </tr>
    ));
  }, [interpreterTimesheets, modalCurrentPage]);

  const fetchModalList = React.useCallback(async (page, extraParams = {}, disableLoader = false) => {
    if (!selectedRow) return;
    if (!disableLoader) setModalLoader(true);

    const params = {
      ...extraParams,
      interpreter_ids: [selectedRow.interpreter_id],
      start_date: filtersRef.current.start_date || selectedRow.start_date,
      end_date: filtersRef.current.end_date || selectedRow.end_date,
      // pageLength: 10 // Assuming fixed or passed
    };

    try {
      const res = await Api.fetchInterpreterTimesheetDetails(page, params);
      if (res?.data?.status === 200) {
        const response = res.data;
        setModalLogs(response.data);
        setModalTotal(response.pagination?.total || 0);
        setModalTotalPages(response.pagination?.last_page || 1);
        setModalCurrentPage(response.pagination?.current_page || 1);
      }
    } catch (err) {
      console.error(err);
    } finally {
      if (!disableLoader) setModalLoader(false);
    }
  }, [selectedRow]);

  //#endregion
  return (
    <>
      {/* ---------------- FILTER FORM ---------------- */}
      <div className="content" style={{ minHeight: "auto" }}>
        <div className="row_main_head">
          <h2 className="main_heading">Interpreter Timesheet</h2>
        </div>
        <div className="card_table">
          <form className="invoicing_form" onSubmit={handleSubmit(onSubmit)}>
            <div className="billings row_Invoice">
              {/* From Date */}
              <div className="row-primary">
                <h2>From&nbsp;Date&nbsp;*</h2>
                <Controller
                  name="start_date"
                  rules={{ required: "This field is required" }}
                  control={control}
                  render={({ field }) => (
                    <div className="input-image-wrapper d-flex flex-column w-100 align-items-start">
                      <div className="input-image">
                        <input
                          type="date"
                          {...field}
                          onChange={(e) =>
                            field.onChange(
                              moment(new Date(e.target.value)).format("YYYY-MM-DD")
                            )
                          }
                        />
                        <img
                          src="/images/celender.png"
                          alt="calendar Icon"
                          className="custom-icon"
                        />
                      </div>
                      {/* ✅ Error Message */}
                      {errors?.start_date?.message && (
                        <div style={{ marginBottom: 10 }}>
                          <ErrorMessage text={errors?.start_date?.message} />
                        </div>
                      )}
                    </div>
                  )}
                />
              </div>

              {/* To Date */}
              <div className="row-primary">
                <h2>To Date *</h2>
                <Controller
                  name="end_date"
                  rules={{ required: "This field is required" }}
                  control={control}
                  render={({ field }) => (

                    <div className="input-image-wrapper d-flex flex-column w-100 align-items-start">
                      <div className="input-image">
                        <input
                          type="date"
                          {...field}
                          onChange={(e) =>
                            field.onChange(
                              moment(new Date(e.target.value)).format("YYYY-MM-DD")
                            )
                          }
                        />
                        <img
                          src="/images/celender.png"
                          alt="calendar Icon"
                          className="custom-icon"
                        />
                      </div>
                      {/* ✅ Error Message */}
                      {errors?.end_date?.message && (
                        <div style={{ marginBottom: 10 }}>
                          <ErrorMessage text={errors?.end_date?.message} />
                        </div>
                      )}
                    </div>
                  )}
                />
              </div>

              {/* Interpreters */}
              <div className="row-primary">
                <h2>Interpreters</h2>
                <Controller
                  name="interpreter_ids"
                  // rules={{ required: "This field is required" }}
                  control={control}
                  render={({ field }) => (
                    <div style={{ width: "100%" }}>
                      <AsyncPaginate
                        menuPlacement="auto"
                        isMulti
                        styles={{
                          ...selectCustomStyles,
                        }}
                        value={interpreterState || []}
                        loadOptions={filteredInterpreterLoadOptions}
                        isClearable
                        escapeClearsValue
                        onChange={(obj) => {
                          setInterpreterState(obj);
                          field.onChange(obj.map((opt) => opt.value));
                        }}
                        additional={{
                          page: 1,
                        }}
                      />
                      {/* {errors?.interpreter_ids?.message && (
                        <div style={{ marginBottom: 10 }}>
                          <ErrorMessage text={errors?.interpreter_ids?.message} />
                        </div>
                      )} */}
                    </div>
                  )}
                />
              </div>
            </div>

            <div className="row-primary row_10 mb-0 p-3">
              <SubmitButton
                handleSubmit={handleSubmit(onSubmit)}
                btnText="Search"
                className={"green"}
              />
              <SubmitButton
                buttonType="button"
                className={"lightBlue"}
                btnText="Reset"
                handleSubmit={handleResetFields}
              />
            </div>
          </form>
        </div>
      </div>

      {/* ---------------- TABLE SECTION ---------------- */}
      <ListLayout
        buttonTitle='Download Timesheet'
        time={false}
        // addButtonDisabled={true}
        renderTableHeader={renderTableHeader}
        renderTableContent={renderTableContent}
        totalPages={totalPages}
        fetchList={(page, extraParams = {}, disableLoader) => {
          const currentFilters = {
            start_date: filtersRef.current.start_date || "",
            end_date: filtersRef.current.end_date || "",
            interpreter_ids: filtersRef.current.interpreter_ids || [],
          };

          const params = {
            ...extraParams,
            ...currentFilters,
          };

          console.log("🧠 Final Params Sent:", params);
          return fetchAdminInterpreterTimesheets(page, params, disableLoader);
        }}
        currentPage={currentPage}
        setCurrentPage={setCurrentPage}
        loader={loader || timesheetLoader}
        noOfItems={total}
        containerStyle={{ marginTop: "0" }}
        searchPlaceholder="Search Date..."
        handleAddPopUp={handleDownloadTimesheet}
        searchTerm={searchTerm}
        addButtonDisabled={!checkPermission("Download Interpreter Timesheets")}
        setSearchTerm={setSearchTerm}
        disableBootstrap={true}
        paginationParams={paginationParams}
        removeLine="removeLine"
      />

      {/* ---------------- DETAIL MODAL ---------------- */}
      <Modal isOpen={viewModal} toggle={toggleViewModal} size="xl" centered>
        <ModalHeader toggle={toggleViewModal}>
          Timesheet Details - {selectedRow?.interpreter_name}
        </ModalHeader>
        <ModalBody>
          {selectedRow && (
            <ListLayout
              buttonTitle={'Download Timesheet'}
              handleAddPopUp={handleDownloadInterpreterTimesheet}
              time={false}
              renderTableHeader={renderModalTableHeader}
              renderTableContent={renderModalTableContent}
              totalPages={modalTotalPages}
              fetchList={fetchModalList}
              currentPage={modalCurrentPage}
              setCurrentPage={setModalCurrentPage}
              loader={modalLoader}
              noOfItems={modalTotal}
              containerStyle={{ marginTop: "0", boxShadow: "none" }}
              searchPlaceholder="Search Date..." // You can keep or remove search
              searchTerm={""} // Search not implemented for modal details yet
              setSearchTerm={() => { }}
              disableBootstrap={true}
            />
          )}
        </ModalBody>
      </Modal>
    </>
  );
}

// ✅ Table Item Component
const TimesheetItems = ({ data, index, current_page, pageLength, handleView }) => {
  const serial = useMemo(() => {
    return index + 1 + (current_page - 1) * pageLength;
  }, [current_page, pageLength]);

  console.log('datasssss:', data);

  return (
    <tr>
      <td>{serial}</td>
      <td>{moment(data?.start_date).format("YYYY-MM-DD")}</td>
      <td>{moment(data?.end_date).format("YYYY-MM-DD")}</td>
      <td>{data?.interpreter_name}</td>
      <td>
        <button
          className="main_button green"
          type="button"
          onClick={() => handleView(data)}
        >
          View
        </button>
      </td>
    </tr>
  );
};

export default InterpreterTimesheets;
